import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReportByIdFailed, loadReportByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadReportById(action) {
  try {
    const url = `${BACKEND_URL}/resources/reports/${action.payload}`;
    yield call(resolveActionPromise(action));
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadReportByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadReportByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadReportByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
